<template>
  <div>
    <cpxlist :status='1'/>
  </div>
</template>

<script>
import cpxlist from '@/components/cpx/cpxlist';
export default {
    name:'cpxprogress',
    components:{
      cpxlist,
    },
    data(){
      return{

      }
    },
    created(){},
    methods:{

    }
}
</script>

<style>

</style>